import MasterSemenarModel from '../Apis/MasterSemenar.js'
import Controller from './Controller.js';

export default class MasterSemenarController extends Controller {

    constructor() {
        super(new MasterSemenarModel());
    }


}